module.exports = __webpack_public_path__ + "img/Feature.ac1ba0a5.jpg";